const options = {
  SamlSetting: ['RapidIdentity', 'Google Apps', 'Microsoft Office 365', 'Other'],
  LtiKey: ['ClassLink', 'Schoology', 'Canvas', 'Other'],
};

export default options;
